"use client";
import { ReactFlowProvider } from "@xyflow/react";
import { useHydrateAtoms } from "jotai/utils";
import {
  Account,
  BuiltInApp,
  RawCanvas,
  Session,
  Toggles,
  isAiPageAtom,
} from "@zapier/canvas-state";
import { CurrentAccountIdProvider } from "@zapier/identity";
import dynamic from "next/dynamic";

import { Canvas } from "../components/Canvas";
import { CanvasHydrator } from "../components/CanvasHydrator";
import { CanvasBackground } from "../components/CanvasBackground";
import { WarningManager } from "../components/WarningManager";
import { CanvasComposerHydrator } from "../components/CanvasComposer";

// Import BuilderNav as a client-only component to solve hydration issues
const BuilderNav = dynamic(
  () => import("../components/BuilderNav").then((mod) => mod.BuilderNav),
  { ssr: false },
);

type Props = {
  canvas: RawCanvas;
  chatbotsApp: BuiltInApp;
  tablesApp: BuiltInApp;
  interfacesApp: BuiltInApp;
  session?: Session;
  account?: Account;
  toggles: Toggles;
  prompt: string;
};

export function AiPage({
  canvas,
  chatbotsApp,
  tablesApp,
  interfacesApp,
  toggles,
  account,
  session,
  prompt,
}: Props) {
  useHydrateAtoms([[isAiPageAtom, true]]);

  return (
    <CurrentAccountIdProvider>
      <ReactFlowProvider>
        <WarningManager />
        <CanvasComposerHydrator>
          <CanvasHydrator
            canvas={canvas}
            chatbotsApp={chatbotsApp}
            tablesApp={tablesApp}
            interfacesApp={interfacesApp}
            toggles={toggles}
            account={account}
            session={session}
            prompt={prompt}
            showAIStreamCreateModal={!toggles.streamingUi}
            isAiPage={true}
          >
            <BuilderNav>
              <Canvas>
                <CanvasBackground />
              </Canvas>
            </BuilderNav>
          </CanvasHydrator>
        </CanvasComposerHydrator>
      </ReactFlowProvider>
    </CurrentAccountIdProvider>
  );
}
